import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  Optional,
} from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { ErrorService } from '../../services/form-utility/error.service';
import { MaskConfig } from '../../../utility/mask-config';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css'],
})
export class TextInputComponent extends BaseInputDirective implements OnInit, OnChanges {
  @Input() maskConfig: MaskConfig;
  @Input() autocomplete?: string;
  hasMask: boolean;
  @Output() richChange = new EventEmitter();
  @Output() richBlur = new EventEmitter();

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();
    this.maskConfig = this.maskConfig || { mask: this.fgInfo.mask };
    this.hasMask = this.maskConfig.mask && this.maskConfig.mask.trim() !== '';
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    this.hasMask = this.fgInfo && this.fgInfo.mask && this.fgInfo.mask.trim() !== '';
  }
}
